export const importPublicKey = async (
  publicKeyBase64: string
): Promise<CryptoKey> => {
  const binaryString = window.atob(publicKeyBase64);
  const binaryDer = Uint8Array.from(binaryString, char => char.charCodeAt(0));

  return window.crypto.subtle.importKey(
    "spki",
    binaryDer.buffer,
    { name: "RSA-OAEP", hash: "SHA-256" },
    false,
    ["encrypt"]
  );
};

export const encryptData = async (
  cryptoKey: CryptoKey,
  plainText: string
): Promise<string> => {
  const encodedData = new TextEncoder().encode(plainText);
  const encryptedBuffer = await window.crypto.subtle.encrypt(
    { name: "RSA-OAEP" },
    cryptoKey,
    encodedData
  );

  const encryptedBytes = new Uint8Array(encryptedBuffer);
  let binary = "";
  encryptedBytes.forEach(byte => {
    binary += String.fromCharCode(byte);
  });

  return window.btoa(binary);
};

export const encryptWithPublicKey = async (
  publicKeyBase64: string,
  plainText: string
): Promise<string> => {
  const cryptoKey = await importPublicKey(publicKeyBase64);
  return encryptData(cryptoKey, plainText);
};
